import { render } from "./AddInstagramUser.vue?vue&type=template&id=304ebc7a&scoped=true"
import script from "./AddInstagramUser.vue?vue&type=script&lang=js"
export * from "./AddInstagramUser.vue?vue&type=script&lang=js"

import "./AddInstagramUser.vue?vue&type=style&index=0&id=304ebc7a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304ebc7a"]])

export default __exports__